import {createReducer, on} from '@ngrx/store';
import {
  fetchTopDownlines,
  fetchTopDownlinesFailure,
  fetchTopDownlinesSuccess,
  fetchTopPromotions,
  fetchTopPromotionsToolsFailure,
  fetchTopPromotionsToolsSuccess
} from './top-listing.actions';
import {ITopListingState} from '@models/ITopListingStore';


const initialState: ITopListingState = {
  data: {}
};

const topListingsReducers = createReducer(initialState,
  on(fetchTopPromotions, (state, {payload}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        promotion_tools: {
          isLoading: true,
          isLoaded: false,
          data: [],
          error: null
        }
      })
    };

    return {...state, ...payloadState};
  }),
  on(fetchTopPromotionsToolsSuccess, (state, {data}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        promotion_tools: {
          isLoading: false,
          isLoaded: true,
          data,
          error: null
        }
      })
    };

    return {...state, ...payloadState};
  }),
  on(fetchTopPromotionsToolsFailure, (state, {error}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        promotion_tools: {
          isLoading: false,
          isLoaded: true,
          data: [],
          error
        }
      })
    };

    return {...state, ...payloadState};
  }),

  on(fetchTopDownlines, (state, {payload}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        downlines: {
          isLoading: true,
          isLoaded: false,
          data: [],
          error: null
        }
      })
    };

    return {...state, ...payloadState};
  }),
  on(fetchTopDownlinesSuccess, (state, {data}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        downlines: {
          isLoading: false,
          isLoaded: true,
          data,
          error: null
        }
      })
    };

    return {...state, ...payloadState};
  }),
  on(fetchTopDownlinesFailure, (state, {error}) => {
    const payloadState = {
      data: Object.assign(state.data, {
        downlines: {
          isLoading: false,
          isLoaded: true,
          data: [],
          error
        }
      })
    };

    return {...state, ...payloadState};
  })
);

export function topListingsReducer(state, action) {
  return topListingsReducers(state, action);
}
